module.exports = __webpack_public_path__ + "img/right_angle.cf362c27.jpg";